exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-arrows input::-webkit-inner-spin-button,.remove-arrows input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0!important}.remove-arrows input[type=number]{-moz-appearance:textfield!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca28e706","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./resources/js/components/b2b/AccountingList.vue
// module id = W793
// module chunks = 0